<div class="user-picker-panel">
  <div class="picker-header">
    <button class="back-btn" (click)="cancelled.emit()" aria-label="Cancel">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </svg>
    </button>
    <span class="picker-title">New Instant Message</span>
    <button
      class="confirm-btn"
      [disabled]="selectedIds().size === 0"
      (click)="confirm()">
      Start
    </button>
  </div>

  <!-- Selected chips -->
  @if (selectedIds().size > 0) {
    <div class="selected-chips">
      @for (id of selectedIds(); track id) {
        <span class="chip" (click)="toggleUser(id)">
          {{ getUserName(id) }}
          <svg viewBox="0 0 24 24" width="14" height="14" fill="#888">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </span>
      }
    </div>
  }

  <!-- Search input -->
  <div class="search-box">
    <label class="search-label">Search User</label>
    <div class="search-input-wrapper">
      <input
        type="text"
        [ngModel]="searchText()"
        (ngModelChange)="onSearch($event)"
        autocomplete="off" />
      <svg class="search-icon" viewBox="0 0 24 24" width="18" height="18" fill="#999">
        <path d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      </svg>
    </div>
  </div>

  <!-- User list -->
  <div class="user-list">
    @for (user of filteredUsers(); track user.id) {
      <button
        class="user-row"
        [class.selected]="isSelected(user.id)"
        (click)="toggleUser(user.id)">
        <span class="avatar avatar-initials">{{ initials(user.displayName) }}</span>
        <span class="user-name">{{ user.displayName }}</span>
        <span class="check-mark" [class.visible]="isSelected(user.id)">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="#5ba4b5">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        </span>
      </button>
    } @empty {
      <p class="empty-hint">No users found</p>
    }
  </div>
</div>
